import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-treatment-personal-data',
  templateUrl: './treatment-personal-data.component.html',
  styleUrls: ['./treatment-personal-data.component.scss'],
})
export class TreatmentPersonalDataComponent implements OnInit {
  htmlContent: string = '';
  date:string
  @Input() logged?: boolean=false;
  @Input() employee_name?:string='';
  @Input() signature_url: any;
  employee:any
  constructor(private authService:AuthService,public modalController : ModalController,private alertService:AlertService) { 
    this.date = this.alertService.getCurrentDate()
  }

  ngOnInit() {
    if(this.logged){
    this.authService.user().subscribe(
      (data:any)=>{
       this.employee_name =data.high_employee.name+" "+data.high_employee.paternal_last_name+" "+data.high_employee.mother_last_name
      }
    );
  }
   }

  closeModal(){
    this.modalController.dismiss();
  }

}
